// TODO: Connect this to a logger that sends the logs to a central place and not just
// the browser console
export const logger = {
    info: (context, message) => {
        console.log(message, context);
    },
    error: (context, message) => {
        console.error(message, context);
    },
};
export const setLogger = (newLogger) => {
    Object.assign(logger, newLogger);
};
//# sourceMappingURL=log.js.map